export default __webpack_public_path__ + "static/media/user_male.d0bb1bef.png";